// utils/authRouting.js
//
// Where a signed-in user belongs when they land on /login. One rule, used by
// AuthGuard (the fallback) AND the login page (the first responder) — the
// page used to push '/' unconditionally, and a user with no organization then
// watched AuthGuard bounce them to /memberships (audit 12t item 12).

/** The home route for an already-authenticated user. */
export function signedInHome(currentOrg) {
    return currentOrg ? '/' : '/memberships';
}
